import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../Imagenes/logo.png'


const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img
          src={logo}
          width={90}
          height={90}
          alt='Imagen vacia'
          />
        </Link>
        {/*<h1 to="/" className="nav-logo">TECNOLOGIA EN TUS MANOS</h1>*/}
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <NavLink to="/" exact="true" onClick={() => setIsMenuOpen(false)}>
            Inicio
          </NavLink>
          <NavLink to="/utilitarios" onClick={() => setIsMenuOpen(false)}>
            Utilitarios
          </NavLink>
          <NavLink to="/juegos" onClick={() => setIsMenuOpen(false)}>
            Juegos
          </NavLink>
          <NavLink to="/nosotros" onClick={() => setIsMenuOpen(false)}>
            Nosotros
          </NavLink>
          <NavLink to="/sugerencias" onClick={() => setIsMenuOpen(false)}>
            Sugerencias
          </NavLink>
        </div>

        <button className="nav-hamburger" onClick={toggleMenu}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;